export class Apb {
  apbAnnuli: ApbAnnulus[];
  finalOperation: FinalOperation;
}

export class ApbAnnulus {
  tubularStringId: string;
  name: string;
  initialOperationId: string | null;
  isVented: boolean;
  maxAllowedHangerPressure: number;
  bleedOffVolume: number;
  isFormationLeakOff: boolean;
  leakOffDepth?: number;
  leakOffDensity?: number;
  updateName?: boolean;

  constructor() {
    this.tubularStringId = '';
    this.name = '';
    this.initialOperationId = null;
    this.isVented = false;
    this.maxAllowedHangerPressure = null;
    this.bleedOffVolume = 0;
    this.isFormationLeakOff = false;
    this.leakOffDepth = null;
    this.leakOffDensity = null;
  }
}

export class FinalOperation {
  id: string;
  name: string;
}

export class ApbResult {
  annulusName: string;
  pressureBuildUp: number;
  fluidExpansionVolume: number;
}

export class ApbInputUi {
  public constructor(init?: Partial<ApbInputUi>) {
    this.selectedAnnulus = init && init.selectedAnnulus || new ApbAnnulus();
  }
  selectedAnnulus: ApbAnnulus;
}

export class ApbResultsUi {
  public constructor(init?: Partial<ApbResultsUi>) {
    this.selectedResultsDisplay = init && init.selectedResultsDisplay || 'grid';
    this.apbAfeSelected = init && init.apbAfeSelected || 'apb';
  }
  selectedResultsDisplay: string;
  apbAfeSelected: string
}

export class ApbResultsGridUi {
  public constructor(init?: Partial<ApbResultsGridUi>) {
    this.selectedRadiusType = init && init.selectedRadiusType || 'outerRadiusChange';
  }
  selectedRadiusType: string;
}
